import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// nm2024 themed components
import { LinkNm2024  } from '../../../../nm2024Theme/components/link/styles';
import { TypographyNm2024  } from '../../../../nm2024Theme/components/typography/styles';
// images
import col1Png from './images/hp-leo-tucker.webp';
import col2Png from './images/hp-tablet-device.webp';
import col3Png from './images/hp-father-and-child.webp';
// styles
import {
  ColStyled,
  LinkStyled,
  PictureStyled,
  RowStyled,
  SectionContainerStyled,
} from './styles';

export default () => {
  return (
    <SectionContainerStyled id='home-page-value-proposition'>
      <Row align='center'>
        <Col align='center'>
          <TypographyNm2024
            component='h2'
            nextElement='graphic'
            typeface='serif'>
            What a Better Way to Money<sup className='nmx-sup'>&#8482;</sup> means <WidowBlock>for you.</WidowBlock>
          </TypographyNm2024>
        </Col>
      </Row>
      <RowStyled align='center'>
        <ColStyled
          medium={10}
          large={4}
          disableTopPadding>
          <Row align='left'>
            <Col
              xsmall={3}
              large={12}
              nested>
              <PictureStyled
                src={col1Png}
                altText='Northwestern Mutual Financial Advisor Leo Tucker'
                variant='round' />
            </Col>
            <Col
              xsmall={9}
              large={12}
              nested>
              <TypographyNm2024
                component='h3'
                nextElement='typography'>
                Better conversations
              </TypographyNm2024>
              <TypographyNm2024 disableBottomPadding>
                Your financial advisor will meet you where you are. They&#39;ll ask deeper questions, and listen closely, to understand your goals and priorities, and how you think about money. Their expertise will help uncover your blind spots and opportunities that might otherwise get overlooked.
              </TypographyNm2024>
            </Col>
          </Row>
        </ColStyled>
        <ColStyled
          medium={10}
          large={4}>
          <Row align='left'>
            <Col
              xsmall={3}
              large={12}
              nested>
              <PictureStyled
                src={col2Png}
                altText='A tablet device displaying a Northwestern Mutual Financial Plan'
                variant='round' />
            </Col>
            <Col
              xsmall={9}
              large={12}
              nested>
              <TypographyNm2024
                component='h3'
                nextElement='typography'>
                Better solutions
              </TypographyNm2024>
              <TypographyNm2024 disableBottomPadding>
                Each recommendation from your advisor&#8212;which could include options from our exclusive portfolio of financial products&#8212;is designed to meet you where you are, at every stage in your life, identifying and addressing any gaps we find along the way.
              </TypographyNm2024>
            </Col>
          </Row>
        </ColStyled>
        <ColStyled
          medium={10}
          large={4}
          disableBorder
          disableBottomPadding>
          <Row align='left'>
            <Col
              xsmall={3}
              large={12}
              nested>
              <PictureStyled
                src={col3Png}
                altText='A father holding his child and kissing them on the cheek.'
                variant='round' />
            </Col>
            <Col
              xsmall={9}
              large={12}
              nested>
              <TypographyNm2024
                component='h3'
                nextElement='typography'>
                Better outcomes
              </TypographyNm2024>
              <TypographyNm2024 disableBottomPadding>
                Watch your money take you further with a plan that&#39;s built specifically around your needs and no one else&#39;s. In fact, independent analysis has shown that clients who follow a comprehensive approach to{' '}
                <LinkNm2024
                  linkUrl='/financial-planning/'
                  variant='primaryDeemphasize'>
                  financial planning
                </LinkNm2024>
                {' '}experienced better outcomes.<sup>1</sup>
              </TypographyNm2024>
            </Col>
          </Row>
        </ColStyled>
      </RowStyled>
      <Row>
        <Col>
          <LinkStyled
            id='home-services-fa-cta'
            variant='buttonLinkPrimary'
            ariaLabel='Connect with a financial professional'
            linkUrl='/find-a-financial-advisor/'>
            Let&#39;s start planning
          </LinkStyled>
        </Col>
      </Row>
    </SectionContainerStyled>
  );
};
